package com.essntl.features.service.ui.addeditservice.components

import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.essntl.features.service.ui.addeditservice.AddEditServiceEvent
import com.essntl.features.service.ui.addeditservice.AddEditServiceState
import com.essntl.uikit.components.input.EsInput
import com.essntl.uikit.components.utils.spacing

@Composable
internal fun HeaderSectionItem(
    state: AddEditServiceState,
    onEvent: (AddEditServiceEvent) -> Unit,
    enabled: Boolean,
) {
    Spacer(modifier = Modifier.height(2.spacing))

    EsInput(
        value = state.service.value.headline ?: "",
        onValueChange = {
            onEvent(
                AddEditServiceEvent.UpdateServiceFields(
                    state.service.value.copy(
                        headline = it,
                    ),
                ),
            )
        },
        label = "Headline",
        placeholder = "Enter headline",
        enabled = enabled,
        modifier = Modifier
            .fillMaxWidth(),
    )
}